import * as React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import BOTable, {
  BOHeader,
  BOFooter,
  BOColumns,
  BOColumn,
  BOBody,
  BORow,
  BOCell
} from "app/components/BOComponents/BOTable/BOTable";
import WalletDetailTopBar from "./WalletDetailTopBar";
import { formatStatusColour } from "app/utils/filters";
import update from "immutability-helper";
import oktaClient from "app/utils/oktaClient";
import ReactFileReader from "react-file-reader";
import * as FontAwesome from "react-fontawesome";

import Dialog from "material-ui/Dialog";
import TextField from "@material-ui/core/TextField";
import BOInlineInputField from "app/components/BOComponents/BOInlineInputField/BOInlineInputField";

import handleMutationError from "app/utils/handleMutationError";

class WalletAddFunds extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      users: null,
      loading: false,
      addUserModalOpen: false,
      newUser: {
        email: "",
        amount: 0,
        submited: false
      },
      description: "",
      batchReference: ""
    };
  }

  componentDidMount() {
    this.runWalletQuery(this.props.match.params.wallet_name);
  }

  componentWillReceiveProps(nextProps: any) {
    if (
      this.props.match.params.wallet_name !== nextProps.match.params.wallet_name
    ) {
      this.runWalletQuery(nextProps.match.params.wallet_name);
    }
  }

  runWalletQuery = (walletName: string): void => {
    this.setState({ loading: true });
    this.props.walletDetails
      .refetch({ name: walletName })
      .then(({ data: { wallet_wallets } }) => {
        const walletData = wallet_wallets[0];
        this.props.setHeader({
          title: `Wallet > ${walletData.display_name} > Add Funds`,
          description: "SnapScan Wallet add funds to users"
        });
        this.setState({ loading: false });
      })
      .catch(error => {
        handleMutationError(error);
        this.setState({
          users: null,
          loading: false
        });
      });
  };

  addUsersToWallet = (users): void => {
    this.handleModalState(false);
    this.setState({ loading: true });
    let userEmails = users.map(user => user.email);
    this.props.userValidation
      .refetch({ emails: userEmails })
      .then(({ data }) => {
        const oldStateUsers = this.state.users ? this.state.users : [];
        const resolvedUsers = users.map(user => {
          const fetchedUser = data
            ? data.users.find(dataUser => dataUser.email === user.email)
            : null;
          return {
            email: user.email,
            external_reference: fetchedUser
              ? fetchedUser.external_reference
              : null,
            snapmin_url: fetchedUser ? fetchedUser.snapmin_url : null,
            amount: user.amount,
            valid: fetchedUser ? true : false
          };
        });
        this.setState({
          users: [...oldStateUsers, ...resolvedUsers],
          loading: false
        });
      })
      .catch(error => {
        handleMutationError(error);
        this.setState({
          users: null,
          loading: false
        });
      });
  };

  submitBatch = () => {
    this.setState({ loading: true });
    const credits = this.state.users.map(user => {
      return {
        user_external_reference: user.external_reference,
        amount: user.amount
      };
    });
    this.props
      .submitBatch({
        variables: {
          credits,
          source: "backoffice",
          wallet_name: this.props.match.params.wallet_name,
          batch_reference: this.state.batchReference,
          description: this.state.description,
          username: oktaClient.getToken().claims.email
        }
      })
      .then(() => {
        this.props.history.push(
          `/snapscan/wallets/${this.props.match.params.wallet_name}/users`
        );
      })
      .catch(error => {
        handleMutationError(error);
        this.setState({
          users: null,
          loading: false
        });
      });
  };

  removeUser = (e, index) => {
    // let remainingUsers = this.state.users.filter(u => u.email !== email);
    let users = this.state.users;
    users.splice(index, 1);
    this.setState({
      users: users.length > 0 ? users : null
    });
  };

  editEmail = (value, index) => {
    let users = this.state.users;
    users[index].email = value;
    this.setState({
      users
    });
  };

  editAmount = (value, index) => {
    let users = this.state.users;
    users[index].amount = parseInt(value);
    this.setState({
      users
    });
  };

  validateInlineEmail = index => {
    this.setState({ loading: true });
    let stateUsers = this.state.users;
    this.props.userValidation
      .refetch({ emails: [stateUsers[index].email] })
      .then(({ data: { users } }) => {
        stateUsers[index] = {
          email: stateUsers[index].email,
          external_reference:
            users.length > 0 ? users[0].external_reference : null,
          snapmin_url: users.length > 0 ? users[0].snapmin_url : null,
          amount: stateUsers[index].amount,
          valid: users.length > 0 ? true : false
        };

        this.setState({
          users: stateUsers,
          loading: false
        });
      })
      .catch(error => {
        handleMutationError(error);
        this.setState({
          users: null,
          loading: false
        });
      });
  };

  handleModalState = (state: boolean): void => {
    if (state) {
      this.setState({
        newUser: {
          email: "",
          amount: 0,
          submited: false
        }
      });
    }
    this.setState({ addUserModalOpen: state });
  };

  handleFormSubmit = e => {
    e.preventDefault();
    if (!this.state.newUser.submited) {
      this.setState(
        update(this.state, {
          newUser: { submited: { $set: true } }
        })
      );
      this.addUsersToWallet([this.state.newUser]);
    }
  };

  handleInputChange = (e): void => {
    const name = e.target.name;
    const value =
      e.target.type === "number"
        ? parseInt(e.target.value)
        : e.target.value.trim();

    this.setState(
      update(this.state, {
        newUser: { [name]: { $set: value } }
      })
    );
  };

  handleCsvUpload = files => {
    let reader = new FileReader();
    reader.onload = e => {
      let usersCsv = (reader.result as string).split("\n").map(row => {
        let user = row.split(",");
        return { email: user[0], amount: parseInt(user[1]) };
      });
      this.addUsersToWallet(usersCsv);
    };
    reader.readAsText(files[0]);
  };

  render() {
    const {
      users,
      loading,
      addUserModalOpen,
      newUser,
      description,
      batchReference
    } = this.state;

    const header = (): JSX.Element => {
      return (
        <BOHeader>
          <button
            className="button"
            onClick={() => this.handleModalState(true)}
          >
            Add User
          </button>
          <ReactFileReader
            handleFiles={this.handleCsvUpload}
            fileTypes={".csv"}
          >
            <button className="button">Upload CSV</button>
          </ReactFileReader>
          <div style={{ marginLeft: "20px" }}>
            <TextField
              name="description"
              type="text"
              value={description}
              onChange={e => this.setState({ description: e.target.value })}
              label="Description"
              style={{ marginRight: "10px" }}
            />
            <TextField
              name="batch_reference"
              type="text"
              value={batchReference}
              onChange={e =>
                this.setState({ batchReference: e.target.value.trim() })
              }
              label="Batch Reference"
            />
          </div>
        </BOHeader>
      );
    };

    const footer = (): JSX.Element => {
      return (
        <BOFooter>
          <button
            className="button"
            onClick={this.submitBatch}
            disabled={
              users && this.state.description.trim()
                ? users.some(user => user.valid === false)
                : true
            }
          >
            Submit Batch
          </button>
        </BOFooter>
      );
    };

    const columns = (): JSX.Element => {
      return (
        <BOColumns>
          <BOColumn>Email</BOColumn>
          <BOColumn align="right">Funds</BOColumn>
          <BOColumn align="right">Actions</BOColumn>
        </BOColumns>
      );
    };

    const body = (): JSX.Element => {
      return (
        <BOBody>
          {users ? (
            users.map(
              (row, index): JSX.Element => {
                return (
                  <BORow
                    key={index}
                    rowColor={row.valid ? null : formatStatusColour("invalid")}
                  >
                    <BOCell>
                      <BOInlineInputField
                        text={row.email}
                        onChange={e => this.editEmail(e, index)}
                        onEnter={() => this.validateInlineEmail(index)}
                      />
                    </BOCell>
                    <BOCell align="right">
                      <BOInlineInputField
                        text={row.amount}
                        textFormat="currency"
                        onChange={e => this.editAmount(e, index)}
                      />
                    </BOCell>
                    <BOCell align="right">
                      <FontAwesome
                        name="times"
                        style={{ color: "red", cursor: "pointer" }}
                        onClick={e => this.removeUser(e, index)}
                      />
                    </BOCell>
                  </BORow>
                );
              }
            )
          ) : (
            <BORow>
              <BOCell colSpan="3" align="center">
                No users added to fund batch
              </BOCell>
            </BORow>
          )}
        </BOBody>
      );
    };

    return (
      <section>
        <WalletDetailTopBar wallet={this.props.match.params.wallet_name} />
        <section className="padded">
          <BOTable
            name="wallet_add_funds_users_table"
            columns={columns()}
            header={header()}
            body={body()}
            footer={footer()}
            loading={loading}
          />

          <Dialog
            title="Add User"
            modal={false}
            open={addUserModalOpen}
            onRequestClose={() => this.handleModalState(false)}
            actions={[]}
          >
            <form onSubmit={this.handleFormSubmit}>
              <div>
                <label>
                  Email:
                  <TextField
                    name="email"
                    type="email"
                    value={newUser.email}
                    onChange={this.handleInputChange}
                  />
                </label>
                <br />
                <label>
                  Amount in cents:
                  <TextField
                    name="amount"
                    type="number"
                    value={newUser.amount}
                    onChange={this.handleInputChange}
                  />
                </label>
              </div>
              <button
                key="add_user_button"
                className="button"
                type="submit"
                disabled={newUser.email && newUser.amount !== 0 ? false : true}
              >
                Add New User
              </button>
            </form>
          </Dialog>
        </section>
      </section>
    );
  }
}

const walletQuery = graphql(
  gql`
    query details($name: String) {
      wallet_wallets(name: $name) {
        name
        display_name
        wallet_users {
          external_reference
          balance
        }
      }
    }
  `,
  {
    name: "walletDetails",
    options(props: any) {
      return {
        variables: {
          name: props.match.params.wallet_name
        }
      };
    }
  }
);

const userQuery = graphql(
  gql`
    query users($emails: [String]) {
      users(emails: $emails) {
        email
        external_reference
        snapmin_url
        wallet_user {
          wallet_wallets {
            name
            balance
          }
        }
      }
    }
  `,
  {
    name: "userValidation"
  }
);

const batchMutation = graphql(
  gql`
    mutation addFunds(
      $credits: [BatchBulkIssueCredit]!
      $source: String!
      $wallet_name: String!
      $batch_reference: String
      $description: String!
      $username: String!
    ) {
      wallet_batch_bulk_issue(
        credits: $credits
        source: $source
        wallet_name: $wallet_name
        batch_reference: $batch_reference
        description: $description
        username: $username
      )
    }
  `,
  {
    name: "submitBatch",
    options(props: any) {
      return {
        fetchPolicy: "network-only",
        errorPolicy: "all"
      };
    }
  }
);

export default compose<any>(
  walletQuery,
  userQuery,
  batchMutation
)(WalletAddFunds);
